import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 16", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.10352 7.79358L7.27218 10.9622L13.3962 4.83691", stroke: "currentcolor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
